// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"49abb6ff","850":"da827277"}[chunkId] + ".chunk.js";
};